// before 20-5-2026

// import React, { useCallback, useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   Get_Last_200_Comment_For_Ddmin_Dashboard_Action,
//   GetActionsData_With_Pages_action,
//   GetAllActionsDatadashboard_action,
//   GetAllActionsDatadashboardMarketer_action,
// } from '../../Redux/Actions/Action_action';
// import { Dashboardlastcommentstable } from './Dashboardlastcommentstable';
// import { CircularProgress, useTheme } from '@mui/material';
// import { Get_All_Top_Saller_Action } from '../../Redux/Actions/UsersAction';
// import { Get_All_Top_Saller_By_Quarter_Action } from '../../Redux/Actions/SalesAction';
// import { Doughnut } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
// import MonthlySalesStats from './MonthlySalesStats';
// import MarkChatReadOutlinedIcon from '@mui/icons-material/MarkChatReadOutlined';

// ChartJS.register(ArcElement, Tooltip, Legend, Title);

// export const LastComments = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const limit = 200;
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(true);
//   const [loadingTopSellers, setLoadingTopSellers] = useState(true);
//   const [loadingQuarterSellers, setLoadingQuarterSellers] = useState(true);
//   const [loadingComments, setLoadingComments] = useState(true);

//   const [userlogin, setuserlogin] = useState('');

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // ✅ جلب بيانات المستخدم من localStorage
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setuserlogin(user);
//     }
//   }, []);

//   // ✅ الفنكشن اللي بتجيب البيانات
//   const getallcommentsnew = useCallback(async () => {
//     if (!userlogin) return;

//     setLoadingComments(true);

//     if (userlogin?.data?.role === 'Admin') {
//       await dispatch(Get_Last_200_Comment_For_Ddmin_Dashboard_Action());
//     } else if (userlogin?.data?.role === 'Marketer') {
//       await dispatch(GetAllActionsDatadashboardMarketer_action(userlogin?.data?.email));
//     }

//     setLoadingComments(false);
//   }, [dispatch, userlogin]);

//   // ✅ تشغيلها بعد تحميل بيانات المستخدم
//   useEffect(() => {
//     getallcommentsnew();
//   }, [getallcommentsnew]);

//   const rescomments = useSelector((state) => state?.AllActions?.Action) || {};

//   // ⭐ التعديل هنا: استخراج البيانات من الـ response بشكل صحيح
//   let commentsarray = [];

//   if (rescomments?.success) {
//     // إذا كانت البيانات تأتي من الـ API الجديد
//     commentsarray = Array.isArray(rescomments?.data) ? rescomments.data : [];
//   } else if (rescomments?.data?.success) {
//     // إذا كانت البيانات متداخلة أكثر
//     commentsarray = Array.isArray(rescomments?.data?.data) ? rescomments.data.data : [];
//   }

//   console.log('Comments data structure:', rescomments);
//   console.log('Processed comments array:', commentsarray);

//   const get_Top_Saller = async () => {
//     setLoadingTopSellers(true);
//     setLoadingQuarterSellers(true);

//     await dispatch(Get_All_Top_Saller_Action());
//     await dispatch(Get_All_Top_Saller_By_Quarter_Action());

//     setLoadingTopSellers(false);
//     setLoadingQuarterSellers(false);
//   };

//   useEffect(() => {
//     get_Top_Saller();
//   }, []);

//   const restopseller = useSelector((state) => state?.Allusers?.All_Top_Saller) || {};
//   let Topsellerarray = (Array.isArray(restopseller?.data) ? restopseller.data : []).filter(
//     (sales) =>
//       sales.salesName !== 'Default' &&
//       sales.salesName !== 'No Sales' &&
//       sales.salesName !== 'Default M' &&
//       sales.salesName !== 'Default T' &&
//       sales.salesName !== 'Default S' &&
//       sales.salesName !== 'Deveolper' &&
//       sales.salesName !== 'Dev',
//   );

//   const restopsellerbyquarter =
//     useSelector((state) => state?.AllSales?.Get_All_Top_Saler_by_Quarter) || {};
//   let Topsellerbyquarterarray = (
//     Array.isArray(restopsellerbyquarter?.data) ? restopsellerbyquarter.data : []
//   ).filter(
//     (sales) =>
//       sales.salesName !== 'Default' &&
//       sales.salesName !== 'No Sales' &&
//       sales.salesName !== 'Default M' &&
//       sales.salesName !== 'Default T' &&
//       sales.salesName !== 'Default S' &&
//       sales.salesName !== 'Deveolper' &&
//       sales.salesName !== 'Dev',
//   );

//   const salesNames = Topsellerbyquarterarray.map((sales) => sales.salesName);
//   const doneDeals = Topsellerbyquarterarray.map((sales) => sales.doneDealsCount);
//   const leads = Topsellerbyquarterarray.map((sales) => sales.totalLeadsCount);

//   const data = {
//     labels: salesNames,
//     datasets: [
//       {
//         label: 'Done Deals',
//         data: doneDeals,
//         backgroundColor: '#102dff',
//         borderColor: 'rgba(75, 192, 192, 1)',
//         borderWidth: 1,
//       },
//       {
//         label: 'Leads',
//         data: leads,
//         backgroundColor: 'rgba(153, 102, 255, 0.7)',
//         borderColor: 'rgba(153, 102, 255, 1)',
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: { position: 'top' },
//       title: { display: true, text: 'Leads and Done Deals per Sales' },
//     },
//     cutout: '50%',
//   };

//   const salesNamessecondchart = Topsellerarray.map((sales) => sales.salesName);
//   const doneDealssecondchart = Topsellerarray.map((sales) => sales.doneDealsCount);
//   const leadssecondchart = Topsellerarray.map((sales) => sales.totalLeadsCount);
//   const topSellerIndex = Topsellerarray.findIndex(
//     (sales) => sales.doneDealsCount === Math.max(...doneDealssecondchart),
//   );

//   const datasecondchart = {
//     labels: salesNamessecondchart,
//     datasets: [
//       {
//         label: 'Done Deals',
//         data: doneDealssecondchart,
//         backgroundColor: doneDealssecondchart.map((_, index) =>
//           index === topSellerIndex ? '#102dff' : 'rgba(75, 192, 192, 0.7)',
//         ),
//         borderColor: 'rgba(75, 192, 192, 1)',
//         borderWidth: 1,
//       },
//       {
//         label: 'Leads',
//         data: leadssecondchart,
//         backgroundColor: 'rgba(153, 102, 255, 0.7)',
//         borderColor: 'rgba(153, 102, 255, 1)',
//         borderWidth: 1,
//       },
//     ],
//   };

//   const optionssecondchart = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { position: 'top' },
//       title: { display: true, text: 'Leads and Done Deals per Sales' },
//     },
//     cutout: '50%',
//   };

//   // ⭐ دالة لتحويل التاريخ لتنسيق مقروء
//   const formatDate = (dateString) => {
//     if (!dateString) return 'No date';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   // ⭐ دالة لاستخراج نص الكومنت
//   const getCommentText = (comment) => {
//     if (comment?.firstcomment?.text) {
//       return comment.firstcomment.text;
//     }
//     if (comment?.secondcomment?.text && comment.secondcomment.text !== '-') {
//       return comment.secondcomment.text;
//     }
//     if (comment?.commentbysales) {
//       return comment.commentbysales;
//     }
//     return 'No comment text available';
//   };

//   // ⭐ دالة لاستخراج اسم الـ sales
//   const getSalesName = (comment) => {
//     return comment?.sales?.name || 'Unknown Sales';
//   };

//   // ⭐ دالة لاستخراج اسم الـ lead
//   const getLeadName = (comment) => {
//     return comment?.lead?.name || 'Unknown Lead';
//   };

//   // ⭐ دالة لاستخراج اسم الـ project
//   const getProjectName = (comment) => {
//     return comment?.project?.name || 'No Project';
//   };

//   // ⭐ دالة لاستخراج اسم الـ stage
//   const getStageName = (comment) => {
//     return comment?.stage?.name || 'No Stage';
//   };

//   // دالة لعرض الـ Spinner
//   const renderSpinner = (message = 'Loading data...') => (
//     <div
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '200px',
//         flexDirection: 'column',
//       }}
//     >
//       <div
//         className="spinner-border"
//         style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
//         role="status"
//       >
//         <span className="visually-hidden">Loading...</span>
//       </div>
//       <p style={{ marginTop: '15px', color: mode === 'dark' ? '#90caf9' : '#666' }}>{message}</p>
//     </div>
//   );

//   // دالة لعرض حالة عدم وجود بيانات
//   const renderNoData = (
//     message = 'No data available',
//     subMessage = 'There are no data for this period',
//   ) => (
//     <div
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '150px',
//         flexDirection: 'column',
//         color: mode === 'dark' ? '#90caf9' : '#666',
//         textAlign: 'center',
//       }}
//     >
//       <svg
//         width="48"
//         height="48"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="1"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       >
//         <circle cx="12" cy="12" r="10" />
//         <line x1="12" y1="8" x2="12" y2="12" />
//         <line x1="12" y1="16" x2="12.01" y2="16" />
//       </svg>
//       <p style={{ marginTop: '10px', fontSize: '1.1em', fontWeight: '500' }}>{message}</p>
//       <p style={{ fontSize: '0.9em', opacity: '0.7' }}>{subMessage}</p>
//     </div>
//   );

//   // ⭐ مكون لعرض الكومنت الفردي
//   const CommentItem = ({ comment, index }) => (
//     <div
//       key={comment.commentId || index}
//       style={{
//         padding: '12px',
//         marginBottom: '10px',
//         borderRadius: '8px',
//         backgroundColor: mode === 'dark' ? '#1e1e1e' : '#f8f9fa',
//         border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//         transition: 'all 0.3s ease',
//       }}
//       className="comment-item"
//     >
//       {/* Header */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'flex-start',
//           marginBottom: '8px',
//         }}
//       >
//         <div>
//           <strong style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}>
//             {getSalesName(comment)}
//           </strong>
//           <div
//             style={{
//               fontSize: '0.85em',
//               color: mode === 'dark' ? '#aaa' : '#666',
//               marginTop: '2px',
//             }}
//           >
//             Lead: {getLeadName(comment)} • Project: {getProjectName(comment)}
//           </div>
//         </div>
//         <div
//           style={{
//             fontSize: '0.75em',
//             color: mode === 'dark' ? '#888' : '#999',
//             textAlign: 'right',
//           }}
//         >
//           {formatDate(comment.stageDate || comment.createdAt)}
//         </div>
//       </div>

//       {/* Comment Text */}
//       <div
//         style={{
//           color: mode === 'dark' ? '#e0e0e0' : '#333',
//           fontSize: '0.9em',
//           lineHeight: '1.4',
//           marginBottom: '8px',
//         }}
//       >
//         {getCommentText(comment)}
//       </div>

//       {/* Footer */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           fontSize: '0.75em',
//           color: mode === 'dark' ? '#888' : '#666',
//         }}
//       >
//         <span>Stage: {getStageName(comment)}</span>
//         <span>Replies: {comment.replies?.length || 0}</span>
//       </div>
//     </div>
//   );

//   return (
//     <div className="last-comments-container fade-in" style={{ marginTop: '50px' }}>
//       <hr />
//       <div className="comments-header">
//         <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Analysis & Comments</div>
//         <div>Across all CRM.</div>
//       </div>

//       <div
//         className="responsive-grid"
//         style={{
//           display: 'flex',
//           flexWrap: 'wrap',
//           gap: '20px',
//           justifyContent: 'space-between',
//           color: mode === 'dark' ? '#90caf9' : '#666',
//           backgroundColor: mode === 'dark' ? '#252525' : 'white',
//         }}
//       >
//         {/* Column 1 - Top Sellers for Month */}
//         <div
//           style={{
//             flex: '1 1 300px',
//             minWidth: '300px',
//             maxWidth: '100%',
//             borderRadius: '15px',
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : 'white',
//           }}
//         >
//           <div
//             style={{
//               maxHeight: '600px',
//               overflowY: 'auto',
//               border: mode === 'dark' ? '1px solid #0f6787' : '1px solid white',
//               borderRadius: '12px',
//               padding: '10px',
//               color: mode === 'dark' ? '#90caf9' : '#0F7687',
//               backgroundColor: mode === 'dark' ? '#252525' : 'white',
//             }}
//           >
//             <div
//               style={{
//                 fontSize: '1.5em',
//                 fontWeight: 'bold',
//                 marginBottom: '15px',
//                 textAlign: 'center',
//                 color: mode === 'dark' ? '#90caf9' : '#666',
//               }}
//             >
//               <svg
//                 width="36"
//                 height="36"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#666"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path d="M3 6L7 14L12 6L17 14L21 6V18H3V6Z" />
//               </svg>
//               Top Sellers for {new Date().toLocaleString('default', { month: 'long' })}{' '}
//               {new Date().getFullYear()}
//             </div>

//             {loadingTopSellers
//               ? renderSpinner('Loading top sellers data...')
//               : !Topsellerarray || Topsellerarray.length === 0
//                 ? renderNoData('No sales data available', 'There are no sales data for this period')
//                 : Topsellerarray.sort((a, b) => b.doneDealsCount - a.doneDealsCount).map(
//                     (sales, index) => {
//                       const rankColor = ['#102dff', '#C0C0C0', '#666'];
//                       const color = rankColor[index] || '#555';
//                       return (
//                         <div
//                           key={sales.salesId}
//                           style={{
//                             color: mode === 'dark' ? '#90caf9' : '#666',
//                             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'space-between',
//                             padding: '10px 14px',
//                             marginBottom: '8px',
//                             borderRadius: '10px',
//                             boxShadow: index < 3 ? '0 2px 6px rgba(0,0,0,0.05)' : 'none',
//                           }}
//                         >
//                           <div
//                             style={{
//                               backgroundColor: mode === 'dark' ? '#666' : '#f5f5f5',
//                               color: mode === 'dark' ? '#90caf9' : '#666',
//                               display: 'flex',
//                               alignItems: 'center',
//                               flex: 1,
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontWeight: 'bold',
//                                 backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                                 color: mode === 'dark' ? '#90caf9' : '#666',
//                                 marginRight: '10px',
//                                 fontSize: '1.2em',
//                                 width: '30px',
//                                 textAlign: 'center',
//                               }}
//                             >
//                               {index === 0 ? (
//                                 <svg
//                                   width="28"
//                                   height="36"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   style={{ color: mode === 'dark' ? '#90caf9' : '#666' }}
//                                   stroke="#666"
//                                   strokeWidth="1.5"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                   <path d="M3 6L7 14L12 6L17 14L21 6V18H3V6Z" />
//                                 </svg>
//                               ) : (
//                                 `#${index + 1}`
//                               )}
//                             </span>
//                             <span style={{ fontWeight: 600 }}>{sales.salesName}</span>
//                           </div>
//                           <div
//                             style={{
//                               textAlign: 'right',
//                               fontSize: '0.85em',
//                               lineHeight: 1.4,
//                               backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                               color: mode === 'dark' ? '#90caf9' : '#0F7687',
//                             }}
//                           >
//                             <div>
//                               <svg
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke={mode === 'dark' ? '#fff' : '#666'}
//                                 strokeWidth="1.4"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//                                 <circle cx="9" cy="7" r="4" />
//                                 <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//                                 <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//                               </svg>
//                               <span style={{ marginLeft: '6px', color: '#666' }}>
//                                 {' '}
//                                 {sales.totalLeadsCount} Leads
//                               </span>
//                             </div>
//                             <div>
//                               <svg
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke={mode === 'dark' ? '#fff' : '#666'}
//                                 strokeWidth="1.4"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <polyline points="20 6 9 17 4 12" />
//                               </svg>
//                               <span style={{ marginLeft: '6px', color: '#666' }}>
//                                 {sales.doneDealsCount} Deals
//                               </span>
//                             </div>
//                             <div>
//                               <svg
//                                 width="20"
//                                 height="20"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke={mode === 'dark' ? '#fff' : '#666'}
//                                 strokeWidth="1.4"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <path d="M3 17L9 11L13 15L21 7" />
//                                 <path d="M21 7H15" />
//                               </svg>
//                               <span style={{ marginLeft: '6px', color: '#666' }}>
//                                 {sales.successRate} Rate
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     },
//                   )}
//           </div>
//         </div>

//         {/* Column 2 - Quarter Sellers */}
//         <div
//           style={{
//             flex: '1 1 300px',
//             minWidth: '300px',
//             maxWidth: '100%',
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           <div
//             style={{
//               maxHeight: '600px',
//               overflowY: 'auto',
//               border: mode === 'dark' ? '1px solid #666' : '1px solid white',
//               borderRadius: '12px',
//               padding: '10px',
//               color: mode === 'dark' ? '#90caf9' : '#666',
//               backgroundColor: mode === 'dark' ? '#252525' : 'white',
//             }}
//           >
//             <div
//               style={{
//                 fontSize: '1.5em',
//                 fontWeight: 'bold',
//                 marginBottom: '15px',
//                 textAlign: 'center',
//                 color: mode === 'dark' ? '#90caf9' : '#666',
//               }}
//             >
//               <svg
//                 width="36"
//                 height="36"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#666"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path d="M3 6L7 14L12 6L17 14L21 6V18H3V6Z" />
//               </svg>
//               Top Sellers for Quarter {Math.floor(new Date().getMonth() / 3) + 1} -{' '}
//               {new Date().getFullYear()}
//             </div>

//             {loadingQuarterSellers
//               ? renderSpinner('Loading quarter sellers data...')
//               : !Topsellerbyquarterarray || Topsellerbyquarterarray.length === 0
//                 ? renderNoData(
//                     'No quarter data available',
//                     'There are no sales data for this quarter',
//                   )
//                 : Topsellerbyquarterarray.sort((a, b) => b.doneDealsCount - a.doneDealsCount).map(
//                     (sales, index) => {
//                       const rankColor = ['#102dff', '#C0C0C0', '#666'];
//                       const color = rankColor[index] || '#555';

//                       const currentYear = new Date().getFullYear();
//                       const currentQuarter = Math.floor(new Date().getMonth() / 3);
//                       const monthsInQuarter = [0, 1, 2].map((i) => {
//                         const month = currentQuarter * 3 + i;
//                         const key = `${currentYear}-${String(month + 1).padStart(2, '0')}`;
//                         return {
//                           key,
//                           label: new Date(currentYear, month).toLocaleString('default', {
//                             month: 'long',
//                           }),
//                         };
//                       });

//                       const leadsPerMonth = { ...sales.leadsPerMonth };
//                       const dealsPerMonth = { ...sales.dealsPerMonth };

//                       return (
//                         <div
//                           className="fade-in"
//                           key={sales.salesId}
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             padding: '10px 14px',
//                             marginBottom: '12px',
//                             color: mode === 'dark' ? '#90caf9' : '#666',
//                             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                             borderRadius: '10px',
//                             boxShadow: index < 3 ? '0 2px 6px rgba(0,0,0,0.05)' : 'none',
//                           }}
//                         >
//                           <div
//                             style={{
//                               color: mode === 'dark' ? '#90caf9' : '#666',
//                               backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'space-between',
//                             }}
//                           >
//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 color: mode === 'dark' ? '#90caf9' : '#666',
//                                 backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   color: mode === 'dark' ? '#90caf9' : '#666',
//                                   backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                                   fontWeight: 'bold',
//                                   marginRight: '10px',
//                                   fontSize: '1.2em',
//                                   width: '30px',
//                                   textAlign: 'center',
//                                 }}
//                               >
//                                 {index === 0 ? (
//                                   <svg
//                                     width="36"
//                                     height="28"
//                                     viewBox="0 0 24 24"
//                                     fill="none"
//                                     stroke="#666"
//                                     strokeWidth="1.5"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     xmlns="http://www.w3.org/2000/svg"
//                                   >
//                                     <path d="M3 6L7 14L12 6L17 14L21 6V18H3V6Z" />
//                                   </svg>
//                                 ) : (
//                                   `#${index + 1}`
//                                 )}
//                               </span>
//                               <span style={{ fontWeight: 600 }}>{sales.salesName}</span>
//                             </div>
//                             <div
//                               style={{
//                                 textAlign: 'right',
//                                 fontSize: '0.85em',
//                                 lineHeight: 1.4,
//                                 color: mode === 'dark' ? '#90caf9' : '#666',
//                                 backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                               }}
//                             >
//                               <div>
//                                 <svg
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke={mode === 'dark' ? '#fff' : '#666'}
//                                   strokeWidth="1.4"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//                                   <circle cx="9" cy="7" r="4" />
//                                   <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//                                   <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//                                 </svg>
//                                 <span style={{ marginLeft: '6px' }}>
//                                   {sales.totalLeadsCount} Leads
//                                 </span>
//                               </div>
//                               <div>
//                                 <svg
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke={mode === 'dark' ? '#fff' : '#666'}
//                                   strokeWidth="1.4"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <polyline points="20 6 9 17 4 12" />
//                                 </svg>
//                                 <span style={{ marginLeft: '6px' }}></span> {sales.doneDealsCount}{' '}
//                                 Deals
//                               </div>
//                               <div>
//                                 <svg
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke={mode === 'dark' ? '#fff' : '#666'}
//                                   strokeWidth="1.4"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M3 17L9 11L13 15L21 7" />
//                                   <path d="M21 7H15" />
//                                 </svg>
//                                 <span style={{ marginLeft: '6px' }}>{sales.successRate}</span>
//                               </div>
//                             </div>
//                           </div>

//                           <div
//                             style={{
//                               marginTop: '10px',
//                               paddingLeft: '40px',
//                               fontSize: '0.9em',
//                               color: '#666',
//                             }}
//                           >
//                             {monthsInQuarter.map((month) => {
//                               const leads = leadsPerMonth[month.key] ?? 0;
//                               const deals = dealsPerMonth[month.key] ?? 0;
//                               return (
//                                 <div
//                                   key={month.key}
//                                   style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     padding: '4px 0',
//                                     color: mode === 'dark' ? '#90caf9' : '#666',
//                                     backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                                   }}
//                                 >
//                                   <span>{month.label}:</span>
//                                   <span>
//                                     {leads} Leads / {deals} Deals
//                                   </span>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       );
//                     },
//                   )}
//           </div>
//         </div>

//         {/* Column 3 - Comments */}
//         <div
//           style={{
//             flex: '1 1 300px',
//             minWidth: '300px',
//             maxWidth: '100%',
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : 'white',
//           }}
//         >
//           <div
//             style={{
//               maxHeight: '600px',
//               overflowY: 'auto',
//               borderRadius: '12px',
//               color: mode === 'dark' ? '#90caf9' : '#666',
//               backgroundColor: mode === 'dark' ? '#252525' : 'white',
//               padding: '10px',
//               border: mode === 'dark' ? '1px solid #0f6787' : '1px solid white',
//             }}
//           >
//             <div
//               style={{
//                 fontSize: '1.5em',
//                 fontWeight: 'bold',
//                 marginBottom: '15px',
//                 textAlign: 'center',
//                 color: mode === 'dark' ? '#90caf9' : '#666',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: '8px',
//               }}
//             >
//               <MarkChatReadOutlinedIcon />
//               Last Comments
//               <span
//                 style={{
//                   fontSize: '0.6em',
//                   backgroundColor: mode === 'dark' ? '#0F7687' : '#0F7687',
//                   color: 'white',
//                   padding: '2px 8px',
//                   borderRadius: '12px',
//                   marginLeft: '8px',
//                 }}
//               >
//                 {commentsarray.length}
//               </span>
//             </div>

//             {loadingComments ? (
//               renderSpinner('Loading comments...')
//             ) : !commentsarray || commentsarray.length === 0 ? (
//               renderNoData('No comments available', 'There are no comments to display')
//             ) : (
//               <div>
//                 {commentsarray.map((comment, index) => (
//                   <CommentItem key={comment.commentId || index} comment={comment} index={index} />
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Charts Section */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-around',
//           alignItems: 'flex-start',
//           flexWrap: 'wrap',
//           gap: '20px',
//           marginTop: '40px',
//         }}
//       >
//         {/* Chart 1: Quarter */}
//         <div
//           style={{
//             flex: '1',
//             minWidth: '400px',
//             maxWidth: '600px',
//           }}
//         >
//           <h2 style={{ textAlign: 'center', color: '#102dff' }}>
//             Sales Performance for Current Quarter
//           </h2>
//           <div style={{ width: '100%', height: '400px' }}>
//             <Doughnut
//               data={data}
//               options={{
//                 ...options,
//                 responsive: true,
//                 maintainAspectRatio: false,
//               }}
//             />
//           </div>
//         </div>

//         {/* Chart 2: This Month */}
//         <div
//           style={{
//             flex: '1',
//             minWidth: '400px',
//             maxWidth: '600px',
//           }}
//         >
//           <h2 style={{ textAlign: 'center', color: '#102dff' }}>Sales Performance (This Month)</h2>
//           <div style={{ width: '100%', height: '400px' }}>
//             <Doughnut
//               data={datasecondchart}
//               options={{
//                 ...optionssecondchart,
//                 responsive: true,
//                 maintainAspectRatio: false,
//               }}
//             />
//           </div>
//         </div>
//       </div>

//       <MonthlySalesStats salesData={Topsellerbyquarterarray} />
//     </div>
//   );
// };





























// 20-5-2026
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_Last_200_Comment_For_Ddmin_Dashboard_Action,
  GetAllActionsDatadashboardMarketer_action,
} from '../../Redux/Actions/Action_action';

import {
  Get_All_Top_Saller_Action,
} from '../../Redux/Actions/UsersAction';
import {
  Get_Top_Projects_Anlasis_IN_DAshboard_Action,
} from '../../Redux/Actions/Projects_Action';
import { Get_All_Top_Saller_By_Quarter_Action } from '../../Redux/Actions/SalesAction';
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  PointElement, LineElement, Tooltip, Legend,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import { CircularProgress, useTheme } from '@mui/material';
import MonthlySalesStats from './MonthlySalesStats';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend);

/* ── helpers ── */
const getInitials = (name = '') =>
  name.split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase();

const avatarBgs = ['#1A3ECF','#0D47A1','#004D40','#4A148C','#BF360C','#1B5E20','#880E4F'];
const dotColors = ['#1A3ECF','#B8860B','#7B1FA2','#00838F','#C62828','#2E7D32','#E65100'];

const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)    return `${diff}s ago`;
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const EXCLUDE = ['Default','No Sales','Default M','Default T','Default S','Deveolper','Dev'];
const accent  = '#1A3ECF';
const gold    = '#B8860B';
const green   = '#10B981';

/* ══════════════════════════════════════════════════════════════════ */
export const LastComments = () => {
  const theme    = useTheme();
  const dark     = theme.palette.mode === 'dark';
  const dispatch = useDispatch();

  /* tokens */
  const surface    = dark ? '#1E1E2E' : '#FFFFFF';
  const border     = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri    = dark ? '#E2E8F0' : '#111827';
  const textSec    = dark ? '#94A3B8' : '#6B7280';
  const commentBg  = dark ? '#2A2A3E' : '#F4F5F7';
  const timelineBg = dark ? 'rgba(255,255,255,0.08)' : '#E8EAF0';

  /* state */
  const [userlogin,         setUserlogin]         = useState(null);
  const [loadingTopSellers, setLoadingTopSellers] = useState(true);
  const [loadingComments,   setLoadingComments]   = useState(false);
  const [loadingMore,       setLoadingMore]       = useState(false);
  const [loadingProjects,   setLoadingProjects]   = useState(true);
  const [allComments,       setAllComments]       = useState([]);
  const [currentPage,       setCurrentPage]       = useState(1);
  const [hasMore,           setHasMore]           = useState(true);
  const [totalComments,     setTotalComments]     = useState(0);

  const lastCommentRef   = useRef(null);
  const commentsPanelRef = useRef(null);

  /* ── user ── */
  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  /* ── projects analysis ── */
  const projectsRaw = useSelector((s) => s?.AllProjects?.GetTop_ProjectsForDashboard);

  useEffect(() => {
    const load = async () => {
      setLoadingProjects(true);
      await dispatch(Get_Top_Projects_Anlasis_IN_DAshboard_Action());
      setLoadingProjects(false);
    };
    load();
  }, [dispatch]);

  const projectsList = (() => {
    const d = projectsRaw;
    if (!d) return null;
    if (Array.isArray(d?.data?.projects)) return d.data.projects;
    if (Array.isArray(d?.projects))       return d.projects;
    if (Array.isArray(d?.data))           return d.data;
    return null;
  })();

  const projectsSummary = (() => {
    const d = projectsRaw;
    if (!d) return null;
    return d?.data?.summary || d?.summary || null;
  })();

  /* ── top sellers ── */
  useEffect(() => {
    const load = async () => {
      setLoadingTopSellers(true);
      await dispatch(Get_All_Top_Saller_Action());
      await dispatch(Get_All_Top_Saller_By_Quarter_Action());
      setLoadingTopSellers(false);
    };
    load();
  }, [dispatch]);

  const restopseller = useSelector((s) => s?.Allusers?.All_Top_Saller) || {};
  const Topsellerarray = (Array.isArray(restopseller?.data) ? restopseller.data : [])
    .filter((s) => !EXCLUDE.includes(s.salesName))
    .sort((a, b) => b.doneDealsCount - a.doneDealsCount);

  const restopQ = useSelector((s) => s?.AllSales?.Get_All_Top_Saler_by_Quarter) || {};
  const Topsellerbyquarterarray = (Array.isArray(restopQ?.data) ? restopQ.data : [])
    .filter((s) => !EXCLUDE.includes(s.salesName));

  /* ── quarter chart ── */
  const currentYear    = new Date().getFullYear();
  const currentQuarter = Math.floor(new Date().getMonth() / 3);
  const qMonths        = [0,1,2].map((i) =>
    new Date(currentYear, currentQuarter * 3 + i).toLocaleString('default', { month: 'short' })
  );
  const quarterRevenue = qMonths.map((_, i) => {
    const key = `${currentYear}-${String(currentQuarter * 3 + i + 1).padStart(2,'0')}`;
    return Topsellerbyquarterarray.reduce((acc, s) => acc + (s.dealsPerMonth?.[key] || 0), 0);
  });
  const quarterTarget = quarterRevenue.map((v) => Math.round(v * 1.3));
  const allQLabels    = [...qMonths, new Date(currentYear, currentQuarter * 3 + 3).toLocaleString('default',{month:'short'})];

  const quarterChartData = {
    labels: allQLabels,
    datasets: [
      { label:'Revenue', data:[...quarterRevenue,0], backgroundColor:accent, borderRadius:6, barPercentage:0.5 },
      { label:'Target',  data:[...quarterTarget, 0], backgroundColor:'rgba(26,62,207,0.15)', borderRadius:6, barPercentage:0.5 },
    ],
  };

  const baseChartOpts = {
    responsive:true, maintainAspectRatio:false,
    plugins:{ legend:{display:false}, tooltip:{mode:'index',intersect:false} },
    scales:{
      x:{ grid:{display:false}, ticks:{color:textSec, font:{size:11}} },
      y:{ grid:{color: dark?'rgba(255,255,255,0.05)':'#F3F4F6'}, ticks:{color:textSec, font:{size:11}} },
    },
  };

  /* ── projects line chart — كل البروجيكتس زي الصورة ── */
  const allProjects      = projectsList || [];
  const conversionValues = allProjects.map((p) => parseFloat(p.conversionRate) || 0);
  const maxConversion    = Math.max(...conversionValues, 0.1);
  const minConversion    = Math.min(...conversionValues, 0);
  const yPadding         = (maxConversion - minConversion) * 0.15 || 0.2;
  const yMin             = Math.max(0, minConversion - yPadding);
  const yMax             = maxConversion + yPadding;

  const trimLabel = (name = '', max = 14) =>
    name.length > max ? name.slice(0, max - 3) + ' ...' : name;

  const projectLineData = allProjects.length > 0 ? {
    labels: allProjects.map((p) => trimLabel(p.projectName || '?')),
    datasets: [
      {
        label               : 'Conversion %',
        data                : conversionValues,
        borderColor         : accent,
        backgroundColor     : 'transparent',
        borderWidth         : 2,
        pointRadius         : 4,                // ✅ نقاط دائرة زي الصورة
        pointBackgroundColor: '#FFFFFF',
        pointBorderColor    : accent,
        pointBorderWidth    : 2,
        pointHoverRadius    : 6,
        tension             : 0.4,
        fill                : false,
      },
    ],
  } : null;

  const projectLineOpts = {
    responsive         : true,
    maintainAspectRatio: false,
    interaction        : { mode: 'index', intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: dark ? '#1E1E2E' : '#FFFFFF',
        borderColor    : dark ? 'rgba(255,255,255,0.12)' : '#E8EAF0',
        borderWidth    : 1,
        titleColor     : dark ? '#E2E8F0' : '#111827',
        bodyColor      : dark ? '#94A3B8' : '#6B7280',
        padding        : 12,
        callbacks: {
          // ✅ عنوان الـ tooltip = اسم البروجيكت الكامل
          title: (items) => {
            const idx = items[0]?.dataIndex;
            return allProjects[idx]?.projectName || items[0]?.label || '';
          },
          // ✅ بيانات كل بروجيكت زي الصورة
          label: (ctx) => {
            const idx = ctx.dataIndex;
            const p   = allProjects[idx];
            if (!p) return '';
            return [
              `Conversion: ${Number(ctx.raw).toFixed(2)}%`,
              `Total Leads: ${(p.totalLeads || 0).toLocaleString()}`,
              `Done Deals: ${(p.totalDoneDeals || 0).toLocaleString()}`,
            ];
          },
          // ✅ مربع لون جنب كل سطر
          labelColor: () => ({
            borderColor    : accent,
            backgroundColor: accent,
            borderWidth    : 2,
            borderRadius   : 3,
          }),
        },
      },
    },
    scales: {
      x: {
        grid : { display: false },
        ticks: {
          color        : textSec,
          font         : { size: 10 },
          maxRotation  : 0,
          minRotation  : 0,
          autoSkip     : false,               // ✅ كل الأسماء تتعرض
        },
        border: { display: false },
      },
      y: {
        min  : yMin,
        max  : yMax,
        grid : { color: dark ? 'rgba(255,255,255,0.05)' : '#F3F4F6' },
        ticks: {
          color   : textSec,
          font    : { size: 10 },
          callback: (v) => Number(v).toFixed(1),
        },
        border: { display: false },
      },
    },
  };

  /* ── comments: fetch first page ── */
  const fetchFirstPage = useCallback(async () => {
    if (!userlogin) return;
    setLoadingComments(true);
    setAllComments([]);
    setCurrentPage(1);
    setHasMore(true);
    try {
      let res;
      if (userlogin?.data?.role === 'Admin')
        res = await dispatch(Get_Last_200_Comment_For_Ddmin_Dashboard_Action(1, 10));
      else if (userlogin?.data?.role === 'Marketer')
        res = await dispatch(GetAllActionsDatadashboardMarketer_action(userlogin?.data?.email, 1, 10));

      const payload = res?.success ? res : res?.data?.success ? res.data : null;
      if (payload) {
        setAllComments(payload.data || []);
        setTotalComments(payload.pagination?.totalItems || payload.totalItems || 0);
        setHasMore(payload.pagination?.hasNextPage || false);
      }
    } catch (e) { console.error(e); }
    finally { setLoadingComments(false); }
  }, [dispatch, userlogin]);

  useEffect(() => { if (userlogin) fetchFirstPage(); }, [userlogin, fetchFirstPage]);

  /* ── comments: fetch next page ── */
  const fetchNextPage = useCallback(async () => {
    if (!userlogin || loadingMore || !hasMore) return;
    setLoadingMore(true);
    const nextPage = currentPage + 1;
    try {
      let res;
      if (userlogin?.data?.role === 'Admin')
        res = await dispatch(Get_Last_200_Comment_For_Ddmin_Dashboard_Action(nextPage, 10));
      else if (userlogin?.data?.role === 'Marketer')
        res = await dispatch(GetAllActionsDatadashboardMarketer_action(userlogin?.data?.email, nextPage, 10));

      const payload = res?.success ? res : res?.data?.success ? res.data : null;
      if (payload && (payload.data || []).length > 0) {
        setAllComments((prev) => [...prev, ...(payload.data || [])]);
        setCurrentPage(nextPage);
        setHasMore(payload.pagination?.hasNextPage || false);
      } else {
        setHasMore(false);
      }
    } catch (e) { console.error(e); }
    finally { setLoadingMore(false); }
  }, [dispatch, userlogin, currentPage, hasMore, loadingMore]);

  /* ── intersection observer ── */
  useEffect(() => {
    if (loadingComments || loadingMore || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) fetchNextPage(); },
      { threshold:0.1, rootMargin:'0px 0px 80px 0px' }
    );
    if (lastCommentRef.current) observer.observe(lastCommentRef.current);
    return () => { if (lastCommentRef.current) observer.unobserve(lastCommentRef.current); };
  }, [loadingComments, loadingMore, hasMore, fetchNextPage, allComments]);

  /* ── field extractors ── */
  const getCommentText = (c) =>
    c?.firstcomment?.text || (c?.secondcomment?.text !== '-' && c?.secondcomment?.text) || c?.commentbysales || '';
  const getSalesName   = (c) => c?.sales?.name   || 'Unknown';
  const getLeadName    = (c) => c?.lead?.name    || '';
  const getProjectName = (c) => c?.project?.name || '';

  const Spinner = ({ size = 24, h = 100 }) => (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:h }}>
      <CircularProgress size={size} style={{ color:accent }} />
    </div>
  );
  const NoData = ({ msg }) => (
    <div style={{ textAlign:'center', padding:'24px 0', color:textSec, fontSize:13 }}>{msg}</div>
  );

  const PANEL_H = 480;

  /* ══════════════════════════════════════════════════════════════════ */
  return (
    <div style={{ marginTop:48 }}>
      <hr style={{ border:'none', borderTop:`1px solid ${border}`, marginBottom:36 }} />

      {/* ── ROW 1: charts ── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))', gap:20, marginBottom:24 }}>

        {/* Quarter */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:textPri }}>Sales Performance for Current Quarter</div>
              <div style={{ fontSize:12, color:textSec, marginTop:3 }}>Revenue distribution across active portfolios</div>
            </div>
            <div style={{ display:'flex', gap:10, alignItems:'center', flexShrink:0 }}>
              {[['Revenue',accent],['Target',gold]].map(([l,c]) => (
                <span key={l} style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, color:textSec }}>
                  <span style={{ width:8, height:8, borderRadius:'50%', background:c, display:'inline-block' }} />{l}
                </span>
              ))}
            </div>
          </div>
          <div style={{ height:220, marginTop:16 }}>
            <Bar data={quarterChartData} options={baseChartOpts} />
          </div>
        </div>

        {/* ✅ Projects Performance — Pure Line Chart زي الصورة */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:textPri }}>Top Projects Performance</div>
              <div style={{ fontSize:12, color:textSec, marginTop:3 }}>Conversion rate across all projects</div>
            </div>
          </div>

          {/* ✅ overflowX scroll عشان كل البروجيكتس تتعرض */}
          <div style={{ overflowX: 'auto', marginTop: 16 }}>
            <div style={{
              height  : 220,
              minWidth: Math.max(600, allProjects.length * 55),
            }}>
              {loadingProjects ? (
                <Spinner h={220} />
              ) : !projectLineData ? (
                <NoData msg="No projects data available" />
              ) : (
                <Line data={projectLineData} options={projectLineOpts} />
              )}
            </div>
          </div>

          {/* summary strip */}
          {!loadingProjects && projectsSummary && (
            <div style={{
              display:'flex', justifyContent:'space-between',
              marginTop:14, paddingTop:12,
              borderTop:`1px solid ${border}`,
              gap:8, flexWrap:'wrap',
            }}>
              {[
                ['Projects',    projectsSummary.totalProjects],
                ['Total Leads', projectsSummary.totalLeads?.toLocaleString()],
                ['Done Deals',  projectsSummary.totalDoneDeals?.toLocaleString()],
                ['Conversion',  projectsSummary.overallConversionRate, green],
              ].map(([label, val, col]) => (
                <div key={label} style={{ textAlign:'center', flex:1 }}>
                  <div style={{ fontSize:10, color:textSec, marginBottom:2 }}>{label}</div>
                  <div style={{ fontSize:17, fontWeight:700, color: col || textPri }}>{val ?? '—'}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── ROW 2: Top Sellers + Last Comments ── */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr minmax(300px,380px)', gap:20, alignItems:'start' }}>

        {/* TOP SELLERS */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px', height:PANEL_H, display:'flex', flexDirection:'column' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexShrink:0 }}>
            <span style={{ fontWeight:700, fontSize:16, color:textPri }}>
              Top Sellers for {new Date().toLocaleString('default',{month:'long'})} {new Date().getFullYear()}
            </span>
            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', background:'#FFF3E0', color:'#E65100', padding:'4px 12px', borderRadius:20 }}>
              GLOBAL RANKING
            </span>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1.5fr 1fr', fontSize:10, fontWeight:600, letterSpacing:'0.08em', color:textSec, textTransform:'uppercase', paddingBottom:10, borderBottom:`1px solid ${border}`, marginBottom:4, flexShrink:0 }}>
            <span>Agent Profile</span>
            <span style={{ textAlign:'center' }}>Active Deals</span>
            <span style={{ textAlign:'center' }}>Success Rate</span>
            <span style={{ textAlign:'right' }}>Revenue</span>
          </div>

          <div style={{ overflowY:'auto', flex:1, scrollbarWidth:'thin' }}>
            {loadingTopSellers ? <Spinner /> : Topsellerarray.length === 0 ? <NoData msg="No sales data" /> :
              Topsellerarray.map((sales, idx) => {
                const rate = sales.totalLeadsCount > 0 ? Math.round((sales.doneDealsCount / sales.totalLeadsCount) * 100) : 0;
                const rev  = sales.amount ? `$${(sales.amount/1e6).toFixed(1)}M` : '—';
                const titles = ['Senior Partner','Luxury Specialist','Portfolio Associate'];
                return (
                  <div key={sales.salesId} style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1.5fr 1fr', alignItems:'center', padding:'12px 0', borderBottom: idx < Topsellerarray.length-1 ? `1px solid ${border}` : 'none' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:40, height:40, borderRadius:'50%', background:avatarBgs[idx % avatarBgs.length], display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#fff', flexShrink:0 }}>
                        {getInitials(sales.salesName)}
                      </div>
                      <div>
                        <div style={{ fontWeight:600, fontSize:13, color:textPri }}>{sales.salesName}</div>
                        <div style={{ fontSize:10, color:textSec, textTransform:'uppercase', letterSpacing:'0.06em' }}>{titles[idx] || 'Sales Agent'}</div>
                      </div>
                    </div>
                    <div style={{ textAlign:'center', fontSize:15, fontWeight:600, color:textPri }}>{sales.doneDealsCount}</div>
                    <div style={{ padding:'0 12px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ flex:1, height:4, background: dark?'rgba(255,255,255,0.08)':'#E8EAF0', borderRadius:99 }}>
                          <div style={{ height:'100%', width:`${Math.min(rate,100)}%`, background:accent, borderRadius:99 }} />
                        </div>
                        <span style={{ fontSize:12, fontWeight:700, color:accent, minWidth:32 }}>{rate}%</span>
                      </div>
                    </div>
                    <div style={{ textAlign:'right', fontSize:13, fontWeight:700, color:textPri }}>{rev}</div>
                  </div>
                );
              })
            }
          </div>
        </div>

        {/* LAST COMMENTS */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 20px', height:PANEL_H, display:'flex', flexDirection:'column' }}>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4, flexShrink:0 }}>
            <span style={{ fontWeight:700, fontSize:17, color:textPri }}>Last Comments</span>
            <span style={{ fontSize:20, color:textSec, cursor:'pointer', letterSpacing:2 }}>⋮</span>
          </div>

          {!loadingComments && allComments.length > 0 && (
            <div style={{ marginBottom:10, flexShrink:0 }}>
              <span style={{ fontSize:11, color: !hasMore ? green : textSec, fontWeight:600 }}>
                {!hasMore
                  ? `✓ All ${totalComments} comments loaded`
                  : `Showing ${allComments.length} of ${totalComments}`}
              </span>
            </div>
          )}

          <div ref={commentsPanelRef} style={{ flex:1, overflowY:'auto', scrollbarWidth:'thin', paddingRight:4 }}>
            {loadingComments ? (
              <Spinner />
            ) : allComments.length === 0 ? (
              <NoData msg="No comments" />
            ) : (
              <div style={{ position:'relative' }}>
                <div style={{ position:'absolute', left:3, top:6, bottom:6, width:1.5, background:timelineBg, borderRadius:99 }} />
                <div style={{ display:'flex', flexDirection:'column', gap:20, paddingLeft:20 }}>
                  {allComments.map((comment, idx) => (
                    <div
                      key={comment.commentId || idx}
                      style={{ position:'relative' }}
                      ref={idx === allComments.length - 1 ? lastCommentRef : null}
                    >
                      <div style={{ position:'absolute', left:-21, top:4, width:9, height:9, borderRadius:'50%', background:dotColors[idx % dotColors.length], border:`2px solid ${surface}`, zIndex:1 }} />
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:2 }}>
                        <span style={{ fontWeight:700, fontSize:14, color:textPri }}>{getSalesName(comment)}</span>
                        <span style={{ fontSize:11, color:textSec, flexShrink:0, marginLeft:8 }}>
                          {timeAgo(comment.stageDate || comment.createdAt)}
                        </span>
                      </div>
                      <div style={{ marginBottom:8 }}>
                        {getProjectName(comment) && (
                          <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:accent, textTransform:'uppercase' }}>
                            {getProjectName(comment)}
                          </span>
                        )}
                        {getLeadName(comment) && (
                          <span style={{ fontSize:10, color:textSec, marginLeft: getProjectName(comment) ? 6 : 0 }}>
                            • {getLeadName(comment)}
                          </span>
                        )}
                      </div>
                      <div style={{ background:commentBg, borderRadius:10, padding:'10px 12px', fontSize:13, color:textSec, lineHeight:1.6 }}>
                        {getCommentText(comment) || '—'}
                      </div>
                    </div>
                  ))}

                  {loadingMore && (
                    <div style={{ textAlign:'center', padding:'12px 0' }}>
                      <CircularProgress size={18} style={{ color:accent }} />
                      <div style={{ fontSize:11, color:textSec, marginTop:4 }}>Loading more…</div>
                    </div>
                  )}

                  {!hasMore && totalComments > 0 && (
                    <div style={{ textAlign:'center', padding:'12px 0 8px', fontSize:11, color:green, fontWeight:700 }}>
                      ✓ You've seen all {totalComments} comments
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {allComments.length > 0 && (
            <div style={{ paddingTop:14, flexShrink:0 }}>
              <button
                style={{ width:'100%', padding:'11px 0', background: dark?'#2A2A3E':'#F4F5F7', border:'none', borderRadius:10, cursor:'pointer', fontSize:13, fontWeight:600, color:textPri, transition:'background 0.15s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = dark?'#3A3A5E':'#E8EAF0'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = dark?'#2A2A3E':'#F4F5F7'; }}
              >
                View All Activity
              </button>
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop:32 }}>
        <MonthlySalesStats salesData={Topsellerbyquarterarray} />
      </div>
    </div>
  );
};
